import React from 'react'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { Roles } from '@/services/repository/users'
import { SuperAdminDashboard } from './dashboard/superadmin/Dashboard'
import { UserDashboard } from './dashboard/user/Dashboard'
import './Dashboard.module.css'
import { ServicemanDashboard } from './dashboard/serviceman/Dashboard'

export const Dashboard = (params: { services: Services, session: CurrentSession }) => {
  const navigate = useNavigate()
  const { services, session } = params

  if (!session) return <div className='spinner'></div>;

  const loadUserDashboard = (session: CurrentSession): JSX.Element => {
    switch (session.user.role) {
      case Roles.SuperAdmin:
        return <SuperAdminDashboard {...params} />
      case Roles.CompanyAdmin:
        return <SuperAdminDashboard {...params} />
      case Roles.ServicemanRole:
        return <ServicemanDashboard {...params} />
      case Roles.User:
        return <UserDashboard {...params} />
      default:
        console.error('Unsupported user', session);
        return <p>Unsupported user</p>;
    }
  };

  return (
    <div className="dashboard">
      {loadUserDashboard(session)}
      {/* <div className='session-info content-body'>
        <div>{session.user.email}</div>
        <div>{session.translates.for('users.role.' + session.user.role)}</div>
        <div><span onClick={() => navigate('/logout')}>{session.translates.for('menu.logout')}</span></div>
      </div> */}
    </div>
  );
};
